import repository from '@/utils/repository';

const resource = '/common';
const auth = '/auth';

export default {
    getDataNotification: () => {
        return repository.get(`${resource}/get-notification`);
    },
    getMessage: (id) => {
        return repository.get(`${resource}/get-message/${id}`);
    },
    logout: () => {
        return repository.get(`${auth}/logout`);
    },
    checkScreenAuthority: (screenid) => {
        return repository.get(`${resource}/check-screen-authority/${screenid}`);
    },
    saveNotify: (code) => {
        return repository.get(`${resource}/save-notify/${code}`);
    },
    changePassWord: (data) => {
        return repository.post(`${resource}/change-password`, data);
    },
    postCommonHeader: (data) => {
        return repository.post(`/move/postCommonHeader`, {
            ...data
        });
    },
    getNotificationMessage: (params = {}) => {
        return repository.get(`move/getNotificationMessage`, { params });
    },
    getDmTopCount: () => {
        return repository.get(`move/getDmTopCount`);
    },
    clearAllCache: () => {
        return repository.get(`/move/cache/clear-all`);
    }
};
